import { render, staticRenderFns } from "./AdminSegmentGeneral.vue?vue&type=template&id=cd858d9e&"
import script from "./AdminSegmentGeneral.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports